import { ProcessoObservacao } from '@app/models/processo-observacao';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { ProcessoService } from '@app/services/processo.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-observacao',
  templateUrl: './observacao.component.html',
})
export class ObservacaoComponent implements OnInit {

  aguardando: boolean = false;
  observacao: string;
  processoId: number;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastr: ToastrService,
    private processoService: ProcessoService) {

  }

  ngOnInit() {
    this.router.events.subscribe(() => window.scrollTo(0, 0));

    this.route.parent.params.subscribe(
      (params: any) => {
        this.processoId = params['id'];
        this.obter();
      });
  }

  obter() {
    this.processoService.obterObservacao(this.processoId).toPromise().then((data: any) => this.observacao = data);
  }

  gravar() {
    this.aguardando = true;
    this.processoService.gravarObservacao(this.processoId, this.observacao).subscribe(
      () => {
        this.aguardando = false;
        this.toastr.success("Anotação salva!", "Sucesso");
      },
      () => {
        this.aguardando = false;
        this.toastr.error("Problema ao salvar anotação.", "Erro");
      }
    );
  }


}
